import { Load } from "./styles";

export const Loading= () => (
    <Load >
      Loading...
    </Load>
);